import React from "react";

const Hero2 = () => {
  return (
    <div class="container my-24 px-52 text-center mx-auto mb-32 text-gray-800 bg-gray-900">
      
    <h1 class="text-xl md:text-6xl xl:text-7xl font-medium tracking-tight  mb-20 my-28">
    <span class=" text-transparent bg-clip-text 
    text-indigo-300">What is DirtyCode?</span></h1>


      <div class="m-auto w-6/12" >

        <iframe
          class="aspect-video w-full rounded-lg shadow-lg"
          src="https://www.youtube.com/embed/2MsN8gpT6jY"
          allowfullscreen="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          data-gtm-yt-inspected-2340190_699="true"
          id="240632615"
        ></iframe>
      </div>

      <div>
      <p class="text-6xl font-semibold leading-relaxed mt-24 mb-4 text-white">
      Ready to get started? Build your own site from scratch or generate one for your project.
        </p>
        <p class="text-xl font-normal leading-relaxed mt-4 mb-4 text-gray-200 opacity-50">
        You get one site per GitHub account and organization,
and unlimited project sites. Let's get started!!
          </p> 
      </div>


      <div class="flex space-x-2 justify-center">
      <div>
        <button type="button" class="inline-block px-6 py-2.5 bg-white
         text-grey-900 font-medium text-xs leading-tight uppercase rounded shadow-lg
          hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg 
          focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition
           duration-150 ease-in-out">User or organization site</button>


        <button type="button" class="inline-block px-6 py-2.5 bg-gray-800
         text-white font-medium text-xs leading-tight uppercase rounded shadow-lg
          hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg
           focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition
            duration-150 ease-in-out">Project site</button>
      </div>
    </div>

    </div>
  );
};

export default Hero2;
